export default __webpack_public_path__ + "static/media/Convit-Z-100-ml-eng.f40e49a2.jpg";